var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"value":_vm.value,"type":"number","label":_vm.config.label,"name":_vm.config.key,"required":_vm.config.required,"id":_vm.config.key,"error":_vm.haveErrors(),"rules":_vm.config.errors,"min":0,"step":1,"suffix":_vm.$t('inputs.minute.minutes')},on:{"input":function (value) { return _vm.emit(value); }}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7133fee0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Minute.vue
// module id = null
// module chunks = 